export const SET_SESSION = 'AUTH0/SET_SESSION'
export const LOGIN = 'AUTH0/LOGIN'
export const LOGOUT = 'AUTH0/LOGOUT'
export const RENEW_SESSION = 'AUTH0/RENEW_SESSION'



// WEBPACK FOOTER //
// ./src/auth0/auth0ActionTypes.js